import styled, { css } from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
import {
  media,
  hideScrollbar,
  buttonCSS,
  type Button,
} from '@simplywallst/ui-core';

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;

type TableCellProps = {
  isSticky?: boolean;
};

export const ScrollPane = styled.div`
  ${media.mdDown`
    overflow-x: auto;
  `}
  ${hideScrollbar}
`;

export const StyledTable = styled('table')`
  width: 100%;
  border-spacing: 0;
  table-layout: auto;
  border-collapse: separate;
  border-spacing: 0 ${({ theme }) => theme.x1}px;
`;

export const TableHeadRow = styled('tr')`
  white-space: nowrap;
`;

export const TableHeadCell = styled('th')<TableCellProps>`
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.textSoft};
  text-align: left;

  padding: ${({ theme }) => theme.x1}px;

  &:first-child {
    padding-left: ${({ theme }) => theme.x2}px;
    width: 100%;
    ${media.mdDown`
      position: sticky;
      left: -1px;
      z-index: 1;
      ${({ isSticky }) =>
        isSticky &&
        css`
          background-color: ${({ theme }) => theme.color.noir};
          box-shadow: 8px 0 5px -2px ${({ theme }) => theme.color.almostBlackRGBA(0.3)};
        `}
    `};
  }
`;

export const TableRow = styled('tr')`
  white-space: nowrap;
  height: 75px;
  ${media.lgUp`
    height: auto;
  `}
`;

export const TableRowCell = styled('td')<TableCellProps>`
  ${({ theme }) => theme.typography.xSmall}

  transition: background-color 0.4s ${cubicBezier};
  padding: 0;
  background-color: ${({ theme }) => theme.color.phantom};
  padding: ${({ theme }) => theme.x1}px;

  &:first-child {
    padding-left: ${({ theme }) => theme.x2}px;
    ${media.lgUp`
      border-top-left-radius: ${({ theme }) => theme.x1}px;
      border-bottom-left-radius: ${({ theme }) => theme.x1}px;
    `}
    ${media.mdDown`
      position: sticky;
      left: -1px;
      z-index: 1;
      ${({ isSticky }) =>
        isSticky &&
        css`
          box-shadow: 8px 0 5px -2px ${({ theme }) => theme.color.almostBlackRGBA(0.3)};
        `}
    `};
  }
  &:last-child {
    ${media.lgUp`
      border-top-right-radius: ${({ theme }) => theme.x1}px;
      border-bottom-right-radius: ${({ theme }) => theme.x1}px;
    `}
  }
`;

export const CtaButton = styled(RouterLink)<Parameters<typeof Button>[0]>`
  ${buttonCSS}
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => `${theme.x0_5}px`};
`;
